module.exports = __webpack_public_path__ + "static/img/1.935ed13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/hangye/20200608/1.png
// module id = J00q
// module chunks = 1